import React, { Fragment, PureComponent } from "react";
import styled, { css, keyframes } from 'styled-components';

import "./MultiVerticalProgressBar.css";

/**
 * @desc Reports MultiVerticalProgressBar Diplaying component
 * @param props
 * @return null
 * @author Praveen George,Jamshith, Lakshmikanth V
 */
class MultiVerticalProgressBar extends PureComponent {
  
  colorStatus  = (color) => {
    return  (color === 0) ? "progress-zero " : (color === 100) ? "progress-fill " : "";
  }

  handleStyle = (percentage) => {
    const keyFrames = keyframes`
      0% { width: 0%; }
      100% { width: ${percentage}%; }
    }`;

    const animation = () => css`
      ${keyFrames} 1s;
    `;

    return animation;
  }

  render() {
    let StyleGreen = styled.div`
    animation: ${this.handleStyle(this.props.greenPercentage)} 2s linear infinite;
    width: ${this.props.greenPercentage}%`;

    let StyleRed = styled.div`
    animation: ${this.handleStyle(this.props.redPercentage)} 2s linear infinite;
    width: ${this.props.redPercentage}%`;

    let StyleBlue = styled.div`
    animation: ${this.handleStyle(this.props.bluePercentage)} 2s linear infinite;
    width: ${this.props.bluePercentage}%`;

    return (
      <Fragment>							
        <div className="progress-wrap">
          {this.props.greenPercentage?
          <div className="progress-outer">
            <StyleGreen 
              className={"progress-bar green progress " + this.colorStatus(Math.round(this.props.greenPercentage))}  
              style={{width: this.props.greenPercentage + "%"}}
            >
              <span>{Math.round(this.props.greenPercentage) !==0?parseFloat(this.props.greenPercentage).toFixed(2) + "%":''}</span>
            </StyleGreen>
            <StyleRed className={"progress-bar red regret " + this.colorStatus(Math.round(this.props.redPercentage)) + ((Math.round(this.props.greenPercentage) !==0 && Math.round(this.props.bluePercentage) ===0)?"progress-fill-end":'')} style={{width: this.props.redPercentage + "%"}}>
              <span>{Math.round(this.props.redPercentage) !==0?parseFloat(this.props.redPercentage).toFixed(2) + "%":''}</span>
            </StyleRed>
            <StyleBlue className={"progress-bar blue unsorted "+ this.colorStatus(Math.round(this.props.bluePercentage))} style={{width: this.props.bluePercentage + "%"}}>
              <span>{Math.round(this.props.bluePercentage) !==0?parseFloat(this.props.bluePercentage).toFixed(2) + "%" :''}</span>
            </StyleBlue>					
          </div>
          :<div className="no-progress-jobs"></div>}
          <p>{this.props.greenPercentage ?this.props.jobTitle:"N/A"}</p>
          {(this.props.greenPercentage && this.props.jobTitle.length > 45) ?
            <div class='tooltip'>
              {this.props.jobTitle}
            </div>
            : null}
        </div>
      </Fragment>
    );
  }
};

export default MultiVerticalProgressBar;



// WEBPACK FOOTER //
// ./src/components/UI/ReportsComponents/MultiVerticalProgressBar/MultiVerticalProgressBar.js